import { findAncestorWithHelixType, HELIX_TYPE_LIST } from '../helixUtils';

export const listSearchEvent = ({ listItemIndex, contentId }, searchTerm) => {
    return {
        name: 'svtplay-search-autocomplete-click',
        type: 'search',
        eventValues: {
            listItemIndex,
            listIndex: 1,
            contentId,
            searchTerm: searchTerm,
        },
    };
};

export const searchQueryEvent = (searchTerm) => {
    return {
        name: 'svtplay-search-query',
        type: 'search',
        eventValues: {
            searchTerm,
        },
    };
};

export const searchShowAll = (searchTerm) => {
    return {
        name: 'svtplay-search-show-all',
        eventValues: {
            searchTerm,
        },
    };
};

export const listTrackingEvent = (
    { listID, listType, listItemIndex, listExpandedState, contentId, leadsToPlayable, ...props },
    clickTarget = null
) => {
    const list = findAncestorWithHelixType(clickTarget, HELIX_TYPE_LIST);
    const lists = document.querySelectorAll(`[data-helix-type="${HELIX_TYPE_LIST}"]`);

    const listIndex = Array.from(lists).indexOf(list);

    if (!listExpandedState && list) {
        const expandButton = list.querySelector('[data-rt="expand-button"]');

        if (expandButton) {
            listExpandedState = expandButton.getAttribute('aria-expanded') === 'true' ? 'expand' : 'collapse';
        }
    }

    return {
        name: 'svtplay-list-tracking',
        eventValues: {
            listID,
            listType,
            listItemIndex,
            listIndex: listIndex > -1 ? listIndex + 1 : -1,
            listExpandedState,
            contentId,
            leadsToPlayable,
            ...props,
        },
    };
};

export const programGuideChangeDateEvent = (date) => ({
    name: 'svtplay-program-guide-change-date',
    eventValues: {
        date,
    },
});

export const programGuideViewChannelEvent = (channel) => ({
    name: 'svtplay-program-guide-view-channel',
    eventValues: {
        channel,
    },
});

export const programGuideExpandItem = (svtId, start, channel) => ({
    name: 'svtplay-program-guide-expand-item',
    eventValues: {
        svtId,
        start,
        channel,
    },
});

export const mainMenuItemClickEvent = (name, index) => ({
    name: 'svtplay-main-menu-item-click',
    eventValues: {
        name,
        index,
    },
});

export const highlightClickEvent = (svtId, name) => ({
    name: 'one-view-interaction',
    type: 'interaction',
    content: { id: svtId, type: 'video' },
    eventValues: {
        interactionComponent: 'highlights-list',
        highlightName: name,
    },
});

export const footerClickEvent = (name) => ({
    name: 'svtplay-footer-click',
    eventValues: {
        name,
    },
});

export const externalTeaser = (index) => ({
    name: 'svtplay-external-teaser',
    eventValues: {
        listItemIndex: index,
    },
});

export const externalArticle = (href) => ({
    name: 'svtplay-external-article',
    eventValues: {
        href,
    },
});

export const genreGridItemClickEvent = (genre) => ({
    name: 'svtplay-genre-grid-item-click',
    eventValues: {
        genre,
    },
});

export const languageSupportClick = (type) => ({
    name: 'svtplay-language-support-click',
    eventValues: {
        type,
    },
});

export const showMorePrograms = (channel) => ({
    name: 'svtplay-program-page-show-more',
    eventValues: {
        channel,
    },
});

export const programFilterClick = (filterName) => ({
    name: 'svtplay-program-page-filter',
    eventValues: {
        filterName,
    },
});

export const programPageAlphabeticList = (letter) => ({
    name: 'svtplay-program-page-alphabetic-list',
    eventValues: {
        letter,
    },
});

export const programPageFilterAbroad = (toggleFilter) => ({
    name: 'svtplay-program-page-filter-abroad',
    eventValues: {
        filterAbroad: toggleFilter ? 'checked' : 'unchecked',
    },
});

export const programPageBackToNavigation = (letter) => ({
    name: 'svtplay-program-page-back-to-navigation',
    eventValues: {
        section: letter,
    },
});

export const titlePlayFromBeginning = (videoId) => ({
    name: 'svtplay-title-play-from-beginning',
    eventValues: {
        videoId,
    },
});

export const titlePlayTrailer = (videoId) => ({
    name: 'svtplay-title-play-trailer',
    eventValues: {
        videoId,
    },
});

export const titlePlayExpandSeason = (name, videoId) => ({
    name: 'svtplay-title-expand-list',
    eventValues: {
        seasonName: name,
        videoId,
    },
});

export const titlePlayShowAllUpcoming = (videoId) => ({
    name: 'svtplay-title-show-all-upcoming',
    eventValues: {
        videoId,
    },
});

export const expandListClick = (eventData) => ({
    name: 'svtplay-expand-list',
    eventValues: {
        listId: eventData.listId,
        action: eventData.action,
    },
});

const setSetting = (name, key, value) => ({
    name,
    type: 'one-view-interaction',
    eventValues: {
        interactionComponent: 'settings',
        [key]: value ? 'on' : 'off',
    },
});

export const trackTTFF = (time) => ({
    name: 'svtplay-time-to-first-frame',
    eventValues: {
        time,
    },
});

export const seasonPicker = (season) => ({
    name: 'svtplay-season-picker',
    type: 'one-view-interaction',
    eventValues: {
        interactionComponent: 'player',
        season,
    },
});

export const toggleEpisodePicker = (value, playedPercentage) => ({
    name: 'svtplay-episode-picker',
    type: 'one-view-interaction',
    eventValues: {
        interactionComponent: 'player',
        episodePicker: value ? 'expanded' : 'hidden',
        playedPercentage,
    },
});

export const trackModalBack = () => ({
    name: 'svtplay-modal-click',
    eventValues: {
        name: 'back',
    },
});

export const trackModalTitle = (svtId) => ({
    name: 'svtplay-modal-click',
    eventValues: {
        title: svtId,
    },
});

export const trackModalEpisode = (svtId) => ({
    name: 'svtplay-modal-click',
    eventValues: {
        episode: svtId,
    },
});

export const trackModalAccessibilityVariant = (variant) => ({
    name: 'svtplay-modal-click',
    eventValues: {
        variant,
    },
});

// A/B-test Skip Credits sep 2021
export const trackModalNextEpisodeButton = (type, svtId = null) => ({
    name: 'svtplay-modal-next-click',
    eventValues: {
        type,
        svtId,
    },
});

export const trackModalNextExposure = (type, svtId = null) => ({
    name: 'svtplay-modal-next-exposure',
    eventValues: {
        type,
        svtId,
    },
});

export const trackFavorite = (titleId, favoriteAdd = true) => {
    const eventValues = {};
    if (favoriteAdd) {
        eventValues.favorite_add = titleId;
    } else {
        eventValues.favorite_remove = titleId;
    }

    return {
        name: 'svtplay-favorite-tracking',
        eventValues,
    };
};

export const setAutoplayNext = (value) => setSetting('set-autoplay-next', 'autoplayNext', value);

export const setVideoCompatibilityMode = (value) =>
    setSetting('set-video-compatibility-mode', 'videoCompatibilityMode', value);

export const setContinueWatching = (value) => setSetting('set-continue-watching', 'continueWatching', value);

export const setEnhancedParentalLock = (value) =>
    setSetting('set-enhanced-parental-lock', 'enhancedParentalLock', value);
